import React, { lazy } from "react";
import GBETNativeInterface from "../../libs/gbetnativeinterface.js";
import GBETClientEventHelper from "../gbetclientevents.js";
const GamesPage1 = lazy(() => import(/* webpackChunkName: "GamesPageV1" */"./v1/games.jsx"));

export default class CasinoSelector extends React.Component {

    componentDidMount() {
        this.unregisterHistoryListener = this.props.history.listen(() => {
            GBETClientEventHelper.fireDelegate("onPageLoaded", {
                mode: configurationSettings.mode, title: document.title, url: document.location.pathname
            });
        });
        GBETClientEventHelper.fireDelegate("onPageLoaded", {
            mode: configurationSettings.mode, title: document.title, url: document.location.pathname
        });
    }

    componentWillUnmount() {
        this.unregisterHistoryListener();
    }

    render() {
        if (GBETNativeInterface.isUIWebView && GBEglobal.settings.casinoSettings && GBEglobal.settings.casinoSettings.hideForIOS) {
            window.location = configurationSettings.baseUrl;
            return "";
        }

        return <GamesPage1 controller={this.props.controller} match={this.props.match} location={this.props.location} onPlayGame={this.props.onPlayGame.bind(this)} togglePanel={this.props.togglePanel.bind(this)} onLoginWidgetShow={this.props.onLoginWidgetShow.bind(this)} onAccountClicked={this.props.onAccountClicked} userContext={this.props.userContext} punterDetails={this.props.punterDetails} modes={this.props.modes} showCasinoSearchPopUp={this.props.showCasinoSearchPopUp} onSearchClicked={this.props.onSearchClicked} />;
    }
}

export { CasinoSelector };